import { Badge, Box, Group, Stack, Text } from '@mantine/core';

const RegistrarCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Text>{rowData.registrar}</Text>
            </Stack>
        </Box>
    );
};

const RegistrarColumn = () => ({
    accessorKey: 'registrar',
    header: 'Registrar',
    size: 2,
    minSize: 160,
    Cell: ({ cell }) => <RegistrarCell cell={cell} />,
});
export default RegistrarColumn;
